<template>
  <v-card outlined>
    <table-search @search="v => (search = v)" />
    <v-data-table
      class="mt-5"
      dense
      fixed-header
      :headers="headers"
      :items="shippingOfflineLocations"
      item-key="id"
      :items-per-page="15"
      :sort-by="['createdAt']"
      :sort-desc="[true]"
      no-data-text="No Records Found!"
      no-results-text="No Records Found!"
      :search="search"
      :loading="pending"
      loading-text="Loading... Please wait"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <row-actions :actions="{ edit: () => doEdit(item), delete: () => doDelete(item) }" />
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        {{ item.createdAt | moment('YYYY/MM/DD hh:mm:ss A') }}
      </template>
      <template v-slot:[`item.updatedAt`]="{ item }">
        {{ item.updatedAt | moment('YYYY/MM/DD hh:mm:ss A') }}
      </template>
      <template v-slot:footer>
        <table-action :actions="{ add: () => toggleShippingOfflineLocationForm('create') }" />
      </template>
    </v-data-table>
    <shipping-offline-location-form />
  </v-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import shippingOfflineLocationHeaders from '@/models/shipping-offline-location-headers';

import ShippingOfflineLocationForm from '@/components/shipping_offline_location/ShippingOfflineLocationForm';

export default {
  name: 'ShippingOfflineLocations',
  data() {
    return { search: '' };
  },
  computed: {
    ...mapState('shippingOfflineLocation', ['shippingOfflineLocations', 'pending']),
    headers: () => shippingOfflineLocationHeaders
  },
  methods: {
    ...mapMutations('confirm', ['confirm']),
    ...mapMutations('shippingOfflineLocation', [
      'toggleShippingOfflineLocationForm',
      'setShippingOfflineLocation'
    ]),
    ...mapActions('shippingOfflineLocation', [
      'createShippingOfflineLocation',
      'updateShippingOfflineLocation',
      'deleteShippingOfflineLocation'
    ]),
    doEdit(sl) {
      this.setShippingOfflineLocation(sl);
      this.toggleShippingOfflineLocationForm('update');
    },
    doDelete(sl) {
      this.confirm({
        message: 'Do you want to delete this Location ?',
        iconColor: 'error',
        acceptAction: () => this.deleteShippingOfflineLocation(sl)
      });
    }
  },
  components: { ShippingOfflineLocationForm }
};
</script>

<style lang="scss" scoped>
.table_search {
  width: 50%;
  @media (min-width: 340px) and (max-width: 767px) {
    width: 60%;
  }
}
</style>
